import {
  Navigate,
  useLocation
} from "react-router";
import { useAuth } from "../features/auth/AuthContext";

function PrivateRoute({ element, ...props }) {
  const { token, isLoggingOut } = useAuth();
  const location = useLocation();

  // During logout the token is cleared before logout() hard-redirects to
  // /login. Rendering <Navigate> here would push /login with the current page
  // as "pathname", cancelling that redirect and sending the NEXT user who logs
  // in on this tab back to the previous user's page.
  if (isLoggingOut?.current) {
    return null;
  }

  return token ? (
    element
  ) : (
    <Navigate
      to="/login"
      state={{ from: props.location, pathname: location?.pathname }}
    />
  );
}

export default PrivateRoute;